import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { DataService } from './data.service';
import Swal from 'sweetalert2';
import { AuthService } from '@auth0/auth0-angular';


@Injectable({
  providedIn: 'root'
})
export class PersonaService {
  private personaSubject = new BehaviorSubject<any>(null);
  persona$: Observable<any> = this.personaSubject.asObservable();
  private personaGuid: string | null = null;

  constructor(
    private router: Router,
    private dataService: DataService,
    private auth: AuthService
  ) {
    // Ensure profile is set when the service is initialized
    this.auth.isAuthenticated$.subscribe((isAuthenticated: any) => {
      if (isAuthenticated) {
        this.setPersona();
      }
    });
  }

  setPersonaGuid(personaGuid: string): void {
    this.personaGuid = personaGuid;
  }

  getPersonaGuid(): string | null {
    return this.personaGuid;
  }

  setPersona(): void {
    this.auth.user$
      .pipe(
        switchMap((user: any) => {
          if (user && user['user_metadata']?.guid_credipal) {
            this.setPersonaGuid(user['user_metadata'].guid_credipal);
            const endpoint = `persona/${user['user_metadata'].guid_credipal}`;
            return this.dataService.getData(endpoint);
          } else {
            return of(null);
          }
        }),
        catchError((error: any) => {
          console.error('Error fetching persona data:', error);
          return of(null);
        })
      )
      .subscribe({
        next: (persona: any) => {
          this.personaSubject.next(persona);
        },
        error: (e: any) => console.error('Error in setPersona subscription:', e),
      });
  }

  getPersona(): any {
    return this.personaSubject.value;
  }

  validaPerfilCompletado(): void {
    this.persona$
      .pipe(take(1))
      .subscribe({
        next: (persona: any) => {
          if (!persona || !this.isPerfilCompleto(persona)) {
            Swal.fire({
              title: 'Perfil incompleto',
              text: 'Por favor, primero debemos completar el perfil de usuario antes de continuar.',
              icon: 'error',
              confirmButtonText: 'OK',
            }).then(() => {
              this.router.navigate(['mi-perfil']);
            }).catch(err => {
              console.error('Error handling Swal promise:', err);
            });
          }
        },
        error: (e: any) => console.error('Error validating perfil:', e),
      });
  }

  private isPerfilCompleto(persona: any): boolean {
    return !!(persona?.identificacionPersona?.rut &&
              persona?.identificacionPersona?.nombre &&
              persona?.identificacionPersona?.apellidoPaterno &&
              persona?.identificacionPersona?.apellidoMaterno);
  }
}
